/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap')
import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import { mixin } from './mixin'
import Vuelidate from 'vuelidate'
import BootstrapVue from 'bootstrap-vue'
import VueGoogleCharts from 'vue-google-charts'
import wysiwyg from 'vue-wysiwyg'
import VueBarcodeScanner from 'vue-barcode-scanner'
import VueAnalytics from 'vue-analytics'
import * as VueGoogleMaps from 'vue2-google-maps'
import VuejsDialog from 'vuejs-dialog'
// include the default style
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
// import { BFormTimepicker } from 'bootstrap-vue'

import VueCookies from 'vue-cookies'

// Libreria de graficos
import VueApexCharts from 'vue-apexcharts'
Vue.component('apexchart', VueApexCharts)

Vue.use(Vuex)
Vue.use(VueRouter)
Vue.mixin(mixin)
Vue.use(Vuelidate)
Vue.use(BootstrapVue)
Vue.use(VueGoogleCharts)
Vue.use(wysiwyg, {})
Vue.use(VueBarcodeScanner)
Vue.use(VueApexCharts)
Vue.use(VueGoogleMaps, {
    load: {
        // key: 'AIzaSyBt8YRz6CwAYRwvfPIDam1diPLv5urpHCo',
        key: 'AIzaSyB2fEzSOqSxjUbTSRkMWaRL_mKqtJ4oLWg',
        libraries: 'places',
    },
})
Vue.use(VuejsDialog, {
    okText: 'Confirmar',
    cancelText: 'Cancelar',
})
Vue.use(VueCookies)

import { store } from './store/store'
import { router } from './router'

// Aca se instala analytics porque se necesita el router
Vue.use(VueAnalytics, {
    id: 'UA-139838156-1',
    router,
    debug: {
        sendHitTask: process.env.NODE_ENV === 'production',
    },
    autoTracking: {
        exception: true,
    },
})

import repo2 from '@repositories/repo2'
Vue.prototype.$repo = repo2

import moment from 'moment'
moment.locale('es')
Vue.prototype.moment = moment

// General Components
import Autocomplete from '@components/UI/Controls/AutocompleteV3/Autocomplete'
import Avatar from '@components/UI/Controls/Avatar/Avatar'
import BtnConfirm from './components/UI/Controls/ButtonConfirm/BtnConfirm.vue'
import ClientsSelectInput from './components/UI/Controls/Forms/ClientsSelectInput.vue'
import DataTable from './components/UI/Controls/DataTable/DataTable.vue'
import DatePicker from './components/UI/Controls/DatePicker/DatePicker.vue'
import DatePickerNative from '@components/UI/Controls/DatePickerNative/DatePickerNative'
import DateTimePicker from './components/UI/Controls/DateTimePicker/DateTimePicker.vue'
import FormDate from '@components/UI/Controls/Forms/FormDate'
import FormInput from '@components/UI/Controls/Forms/FormInput'
import FormPasswordInput from './components/UI/Controls/Forms/FormPasswordInput.vue'
import FormSelect from '@components/UI/Controls/Forms/FormSelect'
import FormSelectInput from './components/UI/Controls/Forms/FormSelectInput.vue'
import FormTextareaInput from './components/UI/Controls/Forms/FormTextareaInput.vue'
import FormTextInput from './components/UI/Controls/Forms/FormTextInput.vue'
import FormTimeInput from '@components/UI/Controls/Forms/FormTimeInput'
import loader from '@components/UI/Complements/Loader'
import Loading from '@components/UI/Complements/Loading'
import MonthsSelectInput from './components/UI/Controls/Forms/MonthsSelectInput.vue'
import NoBr from './components/UI/Layout/NoBr'
import NoDataMessage from './components/UI/Layout/NoDataMessage.vue'
import PageContent from './components/UI/Layout/PageContent.vue'
import PopUp from './components/UI/Controls/PopUp/PopUp.vue'
import SubTitle from './components/UI/Layout/SubTitle.vue'
import TimePickerNative from '@components/UI/Controls/TimePicker/TimePickerNative'
import Title from './components/UI/Layout/Title.vue'
import vSelect from 'vue-select'
import WebCamLite from '@components/UI/Controls/WebCamLite/WebCamLite'
import YearsSelectInput from './components/UI/Controls/Forms/YearsSelectInput.vue'

Vue.component('app-autocomplete', Autocomplete)
Vue.component('app-avatar', Avatar)
Vue.component('app-btn-confirm', BtnConfirm)
Vue.component('app-clients-select-input', ClientsSelectInput)
Vue.component('app-data-table', DataTable)
Vue.component('app-date-picker', DatePicker)
Vue.component('app-date-time-picker', DateTimePicker)
Vue.component('app-datepicker-native', DatePickerNative)
Vue.component('app-form-date', FormDate)
Vue.component('app-form-input', FormInput)
Vue.component('app-form-password-input', FormPasswordInput)
Vue.component('app-form-select-input', FormSelectInput)
Vue.component('app-form-select', FormSelect)
Vue.component('app-form-text-input', FormTextInput)
Vue.component('app-form-textarea-input', FormTextareaInput)
Vue.component('app-form-time-input', FormTimeInput)
Vue.component('app-loading', Loading)
Vue.component('app-months-select-input', MonthsSelectInput)
Vue.component('app-no-data-message', NoDataMessage)
Vue.component('app-nobr', NoBr)
Vue.component('app-page-content', PageContent)
Vue.component('app-pop-up', PopUp)
Vue.component('app-preloading', loader)
Vue.component('app-sub-title', SubTitle)
Vue.component('app-timepicker-native', TimePickerNative)
Vue.component('app-title', Title)
Vue.component('app-webcam-lite', WebCamLite)
Vue.component('app-years-select-input', YearsSelectInput)
Vue.component('v-select', vSelect)
// Vue.component('b-form-timepicker', BFormTimepicker)

let EventBus = new Vue()
// Asignar bus de eventos globales
Object.defineProperties(Vue.prototype, {
    $bus: {
        get: function () {
            return EventBus
        },
    },
})

// Filtros
Vue.filter('datetime', (val) => {
    if (!val) return ''

    let date = moment(val)

    return date.isValid() ? date.format('DD/MM/YYYY HH:mm:ss') : ''
})
Vue.filter('date', (val) => {
    if (!val) return ''

    let date = moment(val)

    return date.isValid() ? date.format('DD/MM/YYYY') : ''
})
Vue.filter('duration', (val) => {
    if (!val) return ''

    let date = moment(val)

    return date.isValid() ? date.fromNow() : ''
})
Vue.filter('yesno', (val) => {
    return !!val ? 'Si' : 'No'
})
Vue.filter('elipsis', (txt, size) => {
    if (!txt) return ''

    var long = size || 10

    if (txt.toString().length <= long) return txt

    return txt.toString().substring(0, long) + '...'
})
Vue.filter('decimal', (val, spaces = 2) => {
    if (!val) return ''
    return parseFloat(val).toFixed(spaces)
})

Vue.filter('percentaje', (val, spaces = 0) => {
    if (!val) return ''
    return `${(parseFloat(val) * 100).toFixed(spaces)} %`
})

Vue.filter('currency', (val) => {
    if (!val) return ''
    return Number(val.toFixed(0)).toLocaleString()
})

const linkifyUrls = require('linkify-urls')
Vue.filter('linkify', (val, classs) => {
    return linkifyUrls(val, {
        attributes: {
            class: classs,
        },
    })
})

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import App from './components/App.vue'

const app = new Vue({
    el: '#app',
    store,
    router,
    components: {
        app: App,
    },
    created() {
        this.$store.dispatch('autoLogin')
    },
})
